import { useState } from "react";
import { historyToPieMask } from "@/lib/utils";
import Correctness from "@/components/common/Correctness";
import ReviewButton from "@/components/common/buttons/ReviewButton";
import SummaryHeader from "@/components/common/SummaryHeader";
import {QUESTIONS_PER_RUN, STANDARD_CATEGORIES_BY_KEY, PLAYLIST_DETAILS} from "@/lib/constants.mjs";
import Pie from "@/components/common/pie/Pie";
import Playlist from "../common/Playlist";
import { GAME_MODES } from "@/lib/constants.mjs";
import Panel from "../panels/Panel";
import ChallengeButton from "../common/buttons/ChallengeButton";
import PlaylistFeedback from "../common/PlaylistFeedback";
import PanelModal from "../modals/PanelModal";
import Button from "../common/buttons/Button";
import ShareButton from "../common/buttons/ShareButton";
import RunsRemaining from "@/components/common/RunsRemaining";

const EndlessChallengeSummary = ({ pursuit = {}, onShare, onChallenge, onQuestionFeedback, onPlaylistFeedback }) => {
  const [open, setOpen] = useState(false);
  const [showPlaylist, setShowPlaylist] = useState(false);
  const pieMask = historyToPieMask(
    pursuit.playlist.questions,
    pursuit.playerChoices
  );
  const showChallengerScore =
    pursuit.challengerGame && typeof pursuit.challengerGame === "object";

  /** @type {"custom" | "custom_share" | "trending" | "staff_pick"} */
  const pursuitType = pursuit.type;
  const subtitle =
    pursuitType === "custom"
      ? "Trivia Playlist made by you!"
      : pursuitType === "custom_share"
        ? "Trivia Playlist made by a friend!"
        : pursuitType === "trending"
          ? "Trending Playlist"
          : pursuitType === "staff_pick"
            ? "Staff Pick"
            : "";

  const togglePlaylist = () => {
    setShowPlaylist(!showPlaylist);
  };

  const challengerPieMask = pursuit?.challengerGame?.playerChoices ? historyToPieMask(
    pursuit.playlist.questions,
    pursuit.challengerGame.playerChoices
    ) : null;
//
  return (
    <>
      <Panel grow={true}>
        <div className={"flex w-full flex-col rounded-lg p-2 pt-2 md:p-4"}>
          <SummaryHeader title={pursuit.playlist.topic} subtitle={subtitle} />
          <div className={"relative my-3 flex flex-col items-center gap-3"}>
            <div className="flex gap-12">
              <div className="mt-2 flex flex-col items-center">
                {showChallengerScore && <p className="mb-2 font-gBold text-xl text-primary">Your Score:</p>}
                <Pie
                  width={80}
                  height={80}
                  monotone={true}
                  color={(pursuit.type && PLAYLIST_DETAILS[pursuit.type])?PLAYLIST_DETAILS[pursuit.type].color: PLAYLIST_DETAILS['endless'].color}
                  entertainment={pieMask & STANDARD_CATEGORIES_BY_KEY.entertainment.mask}
                  geography={pieMask & STANDARD_CATEGORIES_BY_KEY.geography.mask}
                  sports={pieMask & STANDARD_CATEGORIES_BY_KEY.sports.mask}
                  science={pieMask & STANDARD_CATEGORIES_BY_KEY.science.mask}
                  history={pieMask & STANDARD_CATEGORIES_BY_KEY.history.mask}
                  arts={pieMask & STANDARD_CATEGORIES_BY_KEY.arts.mask}
                  data-testid="review-questions"
                  className={"z-10"}
                />
                <Correctness
                  numCorrect={pursuit.playerScore}
                  total={QUESTIONS_PER_RUN}
                />
              </div>
              {showChallengerScore && (
                <div className="mt-2 flex flex-col items-center text-playlist opacity-50">
                  {showChallengerScore && <p className="mb-2 font-gBold text-xl text-playlist">{"Friend's Score:"}</p>}
                  <Pie
                    width={80}
                    height={80}
                    monotone={true}
                    color={
                      pursuit.playerScore === QUESTIONS_PER_RUN
                        ? "#C4141B"
                        : "#46529B"
                    }
                    entertainment={
                      challengerPieMask & STANDARD_CATEGORIES_BY_KEY.entertainment.mask
                    }
                    geography={
                      challengerPieMask & STANDARD_CATEGORIES_BY_KEY.geography.mask
                    }
                    sports={challengerPieMask & STANDARD_CATEGORIES_BY_KEY.sports.mask}
                    science={challengerPieMask & STANDARD_CATEGORIES_BY_KEY.science.mask}
                    history={challengerPieMask & STANDARD_CATEGORIES_BY_KEY.history.mask}
                    arts={challengerPieMask & STANDARD_CATEGORIES_BY_KEY.arts.mask}
                    data-testid="review-challenger-questions"
                    className={"z-10"}
                  />
                  <Correctness
                    numCorrect={pursuit.challengerGame.playerScore}
                    total={QUESTIONS_PER_RUN}
                    className="text-playlist"
                  />
                </div>
              )}
            </div>
            {pursuitType === "custom" && (
              <RunsRemaining className='text-primary' />
            )}
            <ReviewButton open={showPlaylist} onClick={togglePlaylist} />
            {showPlaylist ? (
              <Playlist
                title={"Infinite Pursuit"}
                subtitle={pursuit?.playlist?.topic}
                history={pursuit?.playlist?.questions}
                challengerChoices={pursuit?.challengerGame?.playerChoices}
                playerChoices={pursuit?.playerChoices}
                pursuit={pursuit}
                onQuestionFeedback={onQuestionFeedback}
                onBack={() => setShowPlaylist(false)}
                mode={GAME_MODES.endless}
              />
            ) : null}
            {pursuitType === "custom" ? (
              <ChallengeButton
                onClick={() => {
                  setOpen(true);
                }}
              />
            ) : (
              <ShareButton
                onClick={onShare}
                text={pursuitType === "custom_share" ? "Tell your friend how you did" : undefined}
              />
            )}
            <PlaylistFeedback playlist={pursuit.playlist} onFeedback={onPlaylistFeedback} />
          </div>
        </div>
      </Panel>
      {/* Challenge Modal */}
      <PanelModal open={open} setOpen={setOpen} bgTheme={"bg-geography"} action={'share_dialog_view'} label={'Share Dialog View'}>
        <div className="flex flex-col gap-2">
          <p className="font-gBlack text-center uppercase text-base">CHALLENGE A FRIEND</p>
          <p className="text-center font-gSemi text-lg">Your Trivia Playlist:</p>
          <p className="font-gBlack mb-4 mt-2 text-center text-2xl uppercase">{pursuit.playlist.topic}</p>

          <div className="relative flex flex-col items-center gap-3 text-white">
            <ReviewButton open={showPlaylist} onClick={togglePlaylist} />
            {showPlaylist ? (
              <Playlist
                title={"Infinite Pursuit"}
                subtitle={pursuit?.playlist?.topic}
                history={pursuit?.playlist?.questions}
                playerChoices={pursuit?.playerChoices}
                pursuit={pursuit}
                onShare={onChallenge}
                onQuestionFeedback={onQuestionFeedback}
                onBack={() => setShowPlaylist(false)}
                mode={GAME_MODES.endless}
              />
            ) : null}
          </div>
          <div className="my-6 font-gReg">
            <div className="pl-4">
              <ul className="list list-disc">
                <li className="font-gReg text-base">Tap “Share”, to copy a sharable link to this Trivia Playlist.</li>
                <li className="font-gReg text-base">Your friend gets the same 6 questions you did.</li>
                <li className="font-gReg text-base">They can share their score back to you.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mb-4 flex justify-center gap-3 text-white">
          <Button
            onClick={() => {
              setOpen(false);
            }}
            label={"Back"}
            color="geography"
          />
          <Button
            onClick={onChallenge}
            label={"Share"}
            font="gExtBlack"
            color="white"
            textColor="geography"
          />
        </div>
      </PanelModal>
    </>
  );
};

export default EndlessChallengeSummary;
